module.exports = __webpack_public_path__ + "static/media/reg_pri.dd76d2e4.pdf";